import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { FacetSelection } from '~/features/facets/components/FacetSelection';
import { Accordion } from '~/shared/components/Accordion/Accordion';
import { AccordionItem } from '~/shared/components/Accordion/components/AccordionItem/AccordionItem';
import { SortingSelection } from '~/templates/blocks/components/M170ProductFilter/components/SortingSelection';
import { breakpoints } from '~/theme';

const createLastElementStyle = (theme: Theme) => ({
	borderBottom: `1px solid ${theme.colors.grey40}`,
});

export const StyledAccordionItem = styled(AccordionItem)(({ theme }) => ({
	...createLastElementStyle(theme),
}));

export const StyledSortingAccordionItem = styled(StyledAccordionItem)({
	borderBottom: 'none',

	[breakpoints.sm]: {
		display: 'none',
	},
});

export const StyledSortingSelection = styled(SortingSelection)({
	alignItems: 'flex-start',
});

export const StyledFacetSelection = styled(FacetSelection)({
	[breakpoints.sm]: {
		gridAutoFlow: 'unset',
		gridTemplateColumns: '1fr',
		gridTemplateRows: 'auto',
	},
});

export const StyledFacetsOverlayFormAccordion = styled(Accordion)(({ theme }) => ({
	paddingBottom: theme.space[4],
}));

export const StyledFacetHeaderCount = styled.span(({ theme }) => ({
	fontWeight: theme.fontWeights.regular,
	fontSize: theme.fontSizes.md,
}));
